import { createContext, useContext, useState } from 'react';

const UniversalFilterContext = createContext();

export function UniversalFilterProvider({ children }) {
  const [activeUniversalFilter, setActiveUniversalFilter] = useState(null);

  const toggleUniversalFilter = (filter) => {
    if (activeUniversalFilter?.id === filter.id) {
      setActiveUniversalFilter(null); // turn off if clicked again
    } else {
      setActiveUniversalFilter(filter); // activate new filter
    }
  };

  const clearUniversalFilter = () => {
    setActiveUniversalFilter(null);
  };

  return (
    <UniversalFilterContext.Provider
      value={{
        activeUniversalFilter,
        setActiveUniversalFilter,
        toggleUniversalFilter,
        clearUniversalFilter,
      }}
    >
      {children}
    </UniversalFilterContext.Provider>
  );
}

export function useUniversalFilter() {
  const context = useContext(UniversalFilterContext);

  if (!context) {
    throw new Error(
      'useUniversalFilter must be used within UniversalFilterProvider'
    );
  }

  return context;
}